$(document).ready(function() {

    // Routenplaner
    var googleDirURL = "https://www.google.at/maps/dir/";
    $(document).on("keydown", ".ttgAnreiseInput", function(e) {
        if (e.which == 13) {
            routingURL1 = googleDirURL + $(this).val() + "/" + $(this).attr("data-lat") + "," + $(this).attr("data-lon");
            window.open(routingURL1, "_blank");
        }
    });
    $(document).on("click", ".ttgGoogleDirBtn", function() {
        var inputObj = $(this).prev();
        if (inputObj.val().length > 2) {
            routingURL2 = googleDirURL + inputObj.val() + "/" + inputObj.attr("data-lat") + "," + inputObj.attr("data-lon");
            window.open(routingURL2, "_blank");
        }
    });

    // Static Map Image auf der Detailseite soll klickbar sein und die Modal-Map öffnen
    $(document).on("click", ".ttgStaticMapImage", function() {
        $("#ttgDetailKarteBtn").trigger("click");
    });

    if ($("#ttgKarteVergroessern").length) {
        $("#ttgKarteVergroessern").click(function() {

            // TOURDATA-Detailseite
            if ($('.ttgTourdataDetailSiteColRight').length) {

                var containerWidth = $('.ttgDetailSeiteContainer').width();
                var mapWidth = containerWidth - 30;

                var sliderMaximizeHeight = $('.ttgSlideShowBootstrapInner .item.active').height();
                var mapMaximizeHeight = sliderMaximizeHeight + 1;

                $("#mapRight").css({
                    'width': mapWidth,
                    'height': mapMaximizeHeight,
                    'position': 'absolute',
                    'right': "15px",
                    'left': 'auto',
                    'margin-top': '0'
                });

                $("#ttgDetailSiteCarousel .carousel-control").css('z-index', 0);
                $("#ttgDetailSiteCarousel .carousel-indicators").css('z-index', 0);
                $("#ttgDetailSiteCarousel .ttgBildergalerieLupeBootstrapCarousel").css('z-index', 0);

                if ($(".ttgDataWrapperOnlyNeededForJS").attr("data-mapVersion") == "gmap") {
                    google.maps.event.trigger(ecMap.gMap, 'resize');
                } else {
                    $("#mapRight .leaflet-control-attribution").css("margin-bottom", "0");
                    leafLeftResize(ecMap);
                }

                $("#ttgGrosseKarte").addClass('ttgDisplayNone');
                $("#ttgKleineKarte").removeClass('ttgDisplayNone');

                setTimeout(function() {
                    if ($(this).attr('data-lat') > 0 && $(this).attr('data-lon') > 0 && $(this).attr('data-centerAndZoom') == "true") {
                        ecMap.SetCenterAndZoom(new eContent.LatLong($(this).attr('data-lat'), $(this).attr('data-lon')), 13);
                    } else {
                        ecMap.SetMapView(layer.GetBoundingRectangle());
                    }
                }, 200);


            } else {

                var contentWidth = $('#content').width();

                $("#mapRight").css({
                    'width': contentWidth,
                    'height': '600px',
                    'position': 'absolute',
                    'right': "0",
                    'margin-top': '25px',
                    'left': 'auto'
                });

                $("#ttgDetailSiteCarousel .carousel-control").css('z-index', 1);
                $("#ttgDetailSiteCarousel .carousel-indicators").css('z-index', 1);
                $("#ttgDetailSiteCarousel .ttgBildergalerieLupeBootstrapCarousel").css('z-index', 1);

                if ($(".ttgDataWrapperOnlyNeededForJS").attr("data-mapVersion") == "gmap") {
                    google.maps.event.trigger(ecMap.gMap, 'resize');
                } else {
                    $("#mapRight .leaflet-control-attribution").css("margin-bottom", "0");
                    leafLeftResize(ecMap);
                }

                $("#ttgGrosseKarte").addClass('ttgDisplayNone');
                $("#ttgKleineKarte").removeClass('ttgDisplayNone');

                setTimeout(function() {
                    if ($(this).attr('data-lat') > 0 && $(this).attr('data-lon') > 0 && $(this).attr('data-centerAndZoom') == "true") {
                        ecMap.SetCenterAndZoom(new eContent.LatLong($(this).attr('data-lat'), $(this).attr('data-lon')), 13);
                    } else {
                        ecMap.SetMapView(layer.GetBoundingRectangle());
                    }
                }, 200);

            }

        });
    }

    if ($("#ttgKarteVerkleinern").length) {
        $("#ttgKarteVerkleinern").click(function() {
            // TOURDATA-Detailseite
            if ($('.ttgTourdataDetailSiteColRight').length) {

                var sliderMinimizeHeight = $('.ttgSlideShowBootstrapInner .item.active').height();
                var mapMinimizeHeight = sliderMinimizeHeight + 1;

                $("#mapRight").css({
                    'width': '100%',
                    'height': mapMinimizeHeight,
                    // 'height'	: '226px',
                    'position': 'relative',
                    'margin-top': '35px',
                    'left': 0
                });

                $("#ttgDetailSiteCarousel .carousel-control").css('z-index', 1);
                $("#ttgDetailSiteCarousel .carousel-indicators").css('z-index', 1);
                $("#ttgDetailSiteCarousel .ttgBildergalerieLupeBootstrapCarousel").css('z-index', 1);

                if ($(".ttgDataWrapperOnlyNeededForJS").attr("data-mapVersion") == "gmap") {
                    google.maps.event.trigger(ecMap.gMap, 'resize');
                } else {
                    $("#mapRight .leaflet-control-attribution").css("margin-bottom", "25px");
                    leafLeftResize(ecMap);
                }

                $("#ttgKleineKarte").addClass('ttgDisplayNone');
                $("#ttgGrosseKarte").removeClass('ttgDisplayNone');

                setTimeout(function() {
                    if ($(this).attr('data-lat') > 0 && $(this).attr('data-lon') > 0 && $(this).attr('data-centerAndZoom') == "true") {
                        ecMap.SetCenterAndZoom(new eContent.LatLong($(this).attr('data-lat'), $(this).attr('data-lon')), 13);
                    } else {
                        ecMap.SetMapView(layer.GetBoundingRectangle());
                    }
                }, 200);

            } else {
                $("#mapRight").css({
                    'width': '100%',
                    'height': '226px',
                    'position': 'relative',
                    'left': 0,
                });

                $("#ttgDetailSiteCarousel .carousel-control").css('z-index', 0);
                $("#ttgDetailSiteCarousel .ttgBildergalerieLupeBootstrapCarousel").css('z-index', 1);
                $("#ttgDetailSiteCarousel .carousel-indicators").css('z-index', 1);

                if ($(".ttgDataWrapperOnlyNeededForJS").attr("data-mapVersion") == "gmap") {
                    google.maps.event.trigger(ecMap.gMap, 'resize');
                } else {
                    $("#mapRight .leaflet-control-attribution").css("margin-bottom", "25px");
                    leafLeftResize(ecMap);
                }

                $("#ttgKleineKarte").addClass('ttgDisplayNone');
                $("#ttgGrosseKarte").removeClass('ttgDisplayNone');

                setTimeout(function() {
                    if ($(this).attr('data-lat') > 0 && $(this).attr('data-lon') > 0 && $(this).attr('data-centerAndZoom') == "true") {
                        ecMap.SetCenterAndZoom(new eContent.LatLong($(this).attr('data-lat'), $(this).attr('data-lon')), 13);
                    } else {
                        ecMap.SetMapView(layer.GetBoundingRectangle());
                    }
                }, 200);

            }
        });
    }


});

/* static map laden, wenn alles inkl. Grafiken geladen ist. */
$(window).load(function() {
    //alert('alles geladen');
    if ($("#ttgStaticPrintMapImage").length > 0) {
        var staticImageUrl = '//static.ecmaps.de/' + document.getElementById('ttgStaticPrintMapImage').getAttribute('data-staticmapsUrl');
        document.getElementById('ttgStaticPrintMapImage').setAttribute('src', staticImageUrl);
        //alert(staticImageUrl);
    }

    if ($('.ttgRenderMapForTabKarte').length) {
        $('.ttgRenderMapForTabKarte').children().appendTo('.ttgListKarte');
        $('.ttgRenderMapForTabKarte').remove();
    }

    if ($('.ttgDetailRenderMapForTab').length) {
        $('.ttgDetailRenderMapForTab').children().appendTo('#ttgTabDetailKarte');
        $('.ttgDetailRenderMapForTab').remove();
    }
});

function getPOIs(lat, lng, umkreis) {

    var baseURL = $('base').attr('href');
    $.ajax({
        url: baseURL + '/tourdata-listen/poi.html',
        type: 'POST',
        data: "lat=" + lat + "&lng=" + lng + "&umkreis=" + umkreis + "&show=map",
        beforeSend: function() {
            $("#ajaxLoaderMapRight").show();
            if ($("#karteVergroessern").length) {
                $("#karteVergroessern").attr('data-centerAndZoom', 'false');
            }
            if ($("#karteVerkleinern").length) {
                $("#karteVerkleinern").attr('data-centerAndZoom', 'false');
            }
        },
        success: function(res) {
            if ($("#poiUmkreis").length == 0) {
                $("#content").after(res);
            }
            // karteVergrossern centerAndZoom auf false setzen

            $("#ajaxLoaderMapRight").hide();
        }
    });

}